import { IMAGE_MAX_FILE_SIZE } from '@/components/ui/file-upload/file-upload.constants'
import { OptimizeImageOptions } from '@/utils/file/optimize-image'

export const AMENITY_IMAGE_MAX_BYTES = IMAGE_MAX_FILE_SIZE
export const AMENITY_IMAGE_MAX_OUTPUT_BYTES = IMAGE_MAX_FILE_SIZE
export const AMENITY_IMAGE_ACCEPTED_TYPES = ['JPG', 'JPEG', 'PNG']

// Backend `/amenity/upload` accepts up to 10MB for `image`; leave headroom for the multipart overhead
export const AMENITY_IMAGE_OPTIMIZATION: OptimizeImageOptions = {
  maxBytes: 9_500_000,
  maxDimension: 1600,
  square: true,
  stripMetadata: true,
}
